$('.fileUpload').on('change', function () {
    var input = $(this);
    var label = input.next('label');
    var labelText = label.find('.fileName');

    if (input[0].files.length > 0) {
        labelText.text(input[0].files[0].name);
    } else {
        labelText.text('NO ATTACHED FILE');
    }
});

$('#chkSubscribed').on("click", function () {
    if ($(this).is(':checked')) {
        $('#ResumeForm_Subscribed').val("True");
        $('#JobAlertUpdateForm_Subscribed').val("True");
        $("#alertSettings").show();
    } else {
        $('#ResumeForm_Subscribed').val("False");
        $('#JobAlertUpdateForm_Subscribed').val("False");
        $("#alertSettings").hide();
    }
});